import React, { useEffect, useState } from "react";
import { Button, Container, Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom"; // Import useNavigate and useParams
import { Buffer } from "buffer"; // Import Buffer from the buffer package
import convertNumber from "../../helpers/convertNumber";
import micrologos from "../../assets/micrologos.png";
import { io } from "socket.io-client"; // Import socket.io-client
import axios from "axios"; // Import axios
import {
  END_POINT_SEVER,
  PAYMENT_GATEWAY_URL,
  PAYMENT_SECRET_KEY,
} from "../../constants";
import moment from "moment";
import PaymentModal from "../../components/popup/PaymentModal";
import successImage from  '../../assets/success.png'
export default function CustomerPayment() {
  // State
  const [formData, setFormData] = useState(null);
  const [paymentLinkData, setPaymentLinkData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [linkCode, setLinkCode] = useState(null); // State to store the linkCode
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [totalAmount, setTotalAmount] = useState(0);

  const { id } = useParams();
  // ---------------------------------------------------useEffect----------------------------------------
  // Fetch data from API
  useEffect(() => {
    fetchInstallmentData();
  }, [id]);

  useEffect(() => {
    if (!linkCode) return;
    console.log("Have Link Code", linkCode);

    const socket = io(PAYMENT_GATEWAY_URL, {
      transports: ["websocket", "polling"],
    });

    socket.on(`join::${linkCode}`, async (data) => {
      if (data?.status === "PAYMENT_COMPLETED") {
        console.log("Payment completed:", data);
        const transactionId = data?.transactionId;
        setTimeout(() => {
          console.log("Transaction ID:", transactionId);
          setPaymentLinkData(null);
          setShowModal(false);
          handleUpdateInstallmentStatus(transactionId);
        }, 5000);
      }
    });

    // Cleanup on component unmount
    return () => {
      socket.disconnect();
    };
  }, [linkCode]);


  useEffect(()=>{
      console.log("formData", formData);
      if(formData){
        console.log("Total Amount", formData?.principalAmount + formData?.compensationAmount + formData?.interestRateAmount)
        setTotalAmount(formData?.principalAmount + formData?.compensationAmount + formData?.interestRateAmount)
      }
  },[formData])

  const fetchInstallmentData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${END_POINT_SEVER}/api/loan/get/installment/${id}`
      );
      setFormData(response.data.data);
      setError(null);
    } catch (err) {
      setError(err.message);
      console.error("Error fetching installment data:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateInstallmentStatus = async (transactionId) => {
    try {
      const response = await axios.put(
        `${END_POINT_SEVER}/api/loan/update/installment/${id}`,
        {
          transactionId: transactionId,
          installmentStatus: "SUCCESS",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        console.log("Payment status updated successfully:", response.data);
        fetchInstallmentData();
      }
    } catch (err) {
      console.error("Error updating installment status:", err);
    }
  };

  // Handle payment link creation
  const handlePayment = async () => {
    try {
      const response = await axios.post(
        `${PAYMENT_GATEWAY_URL}/v1/api/link/payment-link`,
        {
          amount: totalAmount,
          description: "MICRO FINANCE PAYMENT",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${Buffer.from(
              `${PAYMENT_SECRET_KEY}`
            ).toString("base64")}`,
          },
        }
      );
      if(response.status ===200){
        console.log("res:::",response?.data)
        const redirectURL = response.data.redirectURL;
        const linkCode = redirectURL.split("linkCode=")[1];
        setPaymentLinkData(response.data);
        setLinkCode(linkCode); // Extract and set the linkCode
        setShowModal(true); // Show the modal
      }
    } catch (err) {
      console.error("Error during payment submission:", err);
      setError("Payment submission failed. Please try again.");
    }
  };

  return (
    <>
      {loading && (
        <div
          className="w-100 d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <span className="loader" />
        </div>
      )}
      {!loading && !error ? (
        <div>
          {formData ? (
            <Container
              fluid
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflowY: "auto",
              }}
            >
              <Row
                className="md:flex-column"
                style={{ minHeight: "100vh", marginBottom: "2rem" }}
              >
                {/* Left side */}
                <Col
                  xs={12}
                  md={6}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div className="text-center">
                    <img
                      src={micrologos}
                      alt="Microfinance Logo"
                      className="image-container w-75"
                    />
                    <p className="mt-3">
                      Microfinance Service ຢູ່ຄຽງຂ້າງທ່ານສະເໝີ
                    </p>
                  </div>
                </Col>

                {/* Right side */}
                <Col
                  xs={12}
                  md={6}
                  style={{
                    padding: "10px",
                    marginTop: "80px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    style={{
                      maxWidth: "500px",
                      margin: "0 auto",
                      border: "1px solid #dee2e6",
                      borderRadius: "5px",
                      padding: "20px",
                      fontFamily: "Arial, sans-serif",
                    }}
                  >
                    {/* Header */}
                    {formData?.installmentStatus === "SUCCESS" && (
                      <div>
                        <img
                          src={successImage}
                          alt="success"
                          style={{ width: "40px", height: "40px" }}
                        />
                      </div>
                    )}
                    <div
                      style={{
                        textAlign: "center",
                        fontWeight: 700,
                        fontSize: "1.75rem",
                        marginBottom: "1.5rem",
                      }}
                    >
                      ໃບບິນຊຳລະງວດ
                    </div>
                    <div className="d-flex justify-content-between">
                      <div style={{ marginBottom: "1.5rem" }}>
                        <div>
                          <strong>ຊື່ສະມາຊິກ: </strong>{" "}
                          {formData?.memberId?.fullName || "N/A"}
                        </div>
                      </div>
                      <div style={{ marginBottom: "1.5rem" }}>
                        <div>
                          <strong>ງວດວັນທີ:</strong>{" "}
                          {moment(formData?.installmentDate).format(
                            "DD-MM-YYYY"
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                      <div style={{ fontSize: "1.2rem" }}>
                        ລາຍລະອຽດການຊໍາລະງວດ
                      </div>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          marginTop: "10px",
                        }}
                      >
                        <thead>
                          <tr>
                            <th
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "left",
                                fontSize: "14px",
                              }}
                            >
                              ລາຍການ
                            </th>
                            <th
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "right",
                                fontSize: "14px",
                              }}
                            >
                              ຈຳນວນເງິນ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ fontSize: "12px" }}>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              ງວດທີ
                            </td>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "right",
                              }}
                            >
                              {formData?.installmentNoteNo || "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              ຈຳນວນເງິນຕົ້ນທືນ
                            </td>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "right",
                              }}
                            >
                              {convertNumber(formData?.principalAmount) || "0"}{" "}
                              ກີບ
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              ຈໍານວນເງີນດອກເບ້ຍ
                            </td>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "right",
                              }}
                            >
                              {convertNumber(formData?.interestRateAmount) ||
                                "0"}{" "}
                              ກີບ
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              ຄ່າປັບໄໝ
                            </td>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "right",
                              }}
                            >
                              {convertNumber(formData?.compensationAmount) ||
                                "0"}{" "}
                              ກີບ
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                              }}
                            >
                              ຈຳນວນເງິນທັງໝົດທີ່ຕ້ອງຈ່າຍ
                            </td>
                            <td
                              style={{
                                border: "1px solid #dee2e6",
                                padding: "8px",
                                textAlign: "right",
                              }}
                            >
                              {convertNumber(
                                formData?.principalAmount +
                                  formData?.compensationAmount +
                                  formData?.interestRateAmount
                              ) || "0"}{" "}
                              ກີບ
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {formData?.installmentStatus === "SUCCESS" ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                        gap: "10px",
                        marginTop: "20px",
                      }}
                    >
                      <h5 style={{ color: "green" }}>ຊໍາລະງວດສໍາເລັດເເລ້ວ</h5>
                      <h2>ຂໍຂອບໃຈ</h2>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "20px",
                      }}
                    >
                      <Button style={{ width: "74%" }} onClick={handlePayment}>
                        ຢືນຢັນການຊຳລະງວດ
                      </Button>
                    </div>
                  )}
                </Col>
              </Row>

              {/* SHOW PAYMENT MODAL HERE */}
              {paymentLinkData && (
                <PaymentModal
                  showModal={showModal}
                  onClose={() => setShowModal(false)}
                  paymentLinkData={paymentLinkData}
                />
              )}
            </Container>
          ) : (
            <Container
              fluid
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "100vh" }}
            >
              <div>Error: {error}</div>
            </Container>
          )}
        </div>
      ) : (
        <div>error</div>
      )}
    </>
  );
}
